import React from 'react';
import {useTranslation} from 'react-i18next';
import {Tag} from 'antd-mobile';

export interface InfoRowProps {
    label: string;
    value: string | number | React.ReactNode | undefined;
    isStatus?: boolean;
}

export const InfoRow: React.FC<InfoRowProps> = ({label, value, isStatus = false}) => {
    const {t} = useTranslation();

    const getStatusColor = (status: string) => {
        switch (status) {
            case 'delivered':
                return 'success';
            case 'sorting':
                return 'primary';
            case 'abnormalLabel':
                return 'warning';
            case 'suspectedMissingInWHS':
                return 'danger';
            default:
                return 'default';
        }
    };

    const getStatusText = (status: string) => {
        return t(`pages.dsp.packageDetail.${status}`);
    };

    return (
        <div className="flex justify-between items-center py-2">
            <span className="text-gray-600 text-sm">{label}:</span>
            <span className="text-gray-900 text-sm font-medium text-right">
                {isStatus && value ? (
                    <Tag color={getStatusColor(value as string)} fill="outline">
                        {getStatusText(value as string)}
                    </Tag>
                ) : (
                    value || '-'
                )}
            </span>
        </div>
    );
};
